import React from 'react';

const WinkPaidStudyHeader = ({ step }) => {
    return (
        <>
            <h4>유료학습 신청</h4>
            <div className="color-box">
                <p>
                    No.1 유초등 학습지 윙크를 선택해 주셔서 감사합니다.
                    <br />
                    아래의 단계에 맞춰 신청해 주시면 됩니다.
                    <br />
                    <br />
                </p>
                <div className="paid-study-wifi">
                    ※ 윙크 학습은{' '}
                    <em className="text-color03 underline">
                        무선 공유기를 통한 와이파이 연결이 필수
                    </em>
                    입니다.
                </div>
            </div>
            <div className="section-menu">
                <ul>
                    {[
                        '1. 아이 선택',
                        '2. 학습 선택',
                        '3. 배송정보 입력',
                        '4. 결제',
                    ].map((text, index) => (
                        <li
                            key={index}
                            className={step === index + 1 ? 'on' : ''}
                        >
                            <a>{text}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default WinkPaidStudyHeader;
